// extracted by mini-css-extract-plugin
export default {"container":"FiltersComponent_container__+28FF","types__description":"FiltersComponent_types__description__9hQP2"};